









import Vue from 'vue';
import { refreshAccessToken } from 'mycorems-app-accounts';

export default Vue.extend({
  props: {
    emailCampaignId: {
      type: String,
      required: true,
    },
  },
  methods: {
    download(): void {
      refreshAccessToken().then(() => {
        window.location.href = `${window.env.API_URL}/reports/${this.emailCampaignId}.pdf`;
      });
    },
  },
});
